import logo from "./logo.svg";
import homePageBg from "./homePageBg.png";
import messageRightIcon from "./message-right-icon.png";
import messageHomeIcon from "./home-message-icon.png";
import transDetailsIcon1 from "./transDetailsIcon1.png";
import transDetailsIcon2 from "./transDetailsIcon2.png";
import transDetailsIcon3 from "./transDetailsIcon3.png";
import wholesaleIcon1 from "./wholesaleAndRetailImages/wholesaleIcon1.png";
import wholesaleIcon2 from "./wholesaleAndRetailImages/wholesaleIcon2.png";
import wholesaleIcon3 from "./wholesaleAndRetailImages/wholesaleIcon3.png";
import wholesaleIcon4 from "./wholesaleAndRetailImages/wholesaleIcon4.png";
import catalogImage1 from "./catalogImages/catalogImg1.png";
import srkApart1 from "./srkApartImages/srk-apart-icon1.svg";
import srkApart2 from "./srkApartImages/srk-apart-icon2.svg";
import srkApart3 from "./srkApartImages/srk-apart-icon3.svg";
import srkInfraIcon from "./srkInfraImages/srkInfraIcon.svg";
import srkConversationIcon from "./srkConversationImages/srkConversationIcon.svg";
import catalogHorbor from "./catalogImages/catalog-horbor.png";
import catalogJivraj from "./catalogImages/catalog-jivraj.png";
import catalogAmazonAtlantis from "./catalogImages/catalog-amazonAtlantis.png";
import catalogEcoBag from "./catalogImages/catalog-ecoBag.png";
import srkTragderQualityCommunity from "./srkTragderQualityCommunity.jpeg";
import srkAboutImage from "./srkAboutImages/about-story.jpg";
import srkEmail from "./srkContactImages/contact-email.svg";
import srkPhone from "./srkContactImages/contact-phone.svg";
import srkLocation from "./srkContactImages/contact-location.svg";
import srkExportProducts from "./srkAboutImages/srkExportProducts.jpg";
import srkInfraImage from "./srkInfraImages/srk-infraImage.jpg";
import productBannerImage from "./srkProductsImages/productBannerImage.svg";
import srkFooterLogo from "./srkFooterImage/srk-footer-logo.svg";

import srkCardamom1 from "./srkProductsImages/srk-Cardamom1.jpg";
import srkBizzaBox1 from "./srkProductsImages/srk-bizzaBox1.jpg";
import srkBizzaBox2 from "./srkProductsImages/srk-bizzaBox2.jpg";
import srkCakeBox1 from "./srkProductsImages/srk-cakeBox1.jpg";
import srkCakeBox2 from "./srkProductsImages/srk-cakeBox2.jpg";
import srkCandy1 from "./srkProductsImages/srk-candy1.jpg";
import srkCandy2 from "./srkProductsImages/srk-candy2.jpg";
import srkCandy3 from "./srkProductsImages/srk-candy3.jpg";
import srkCandy4 from "./srkProductsImages/srk-candy4.jpg";
import srkCloth1 from "./srkProductsImages/srk-cloth1.jpg";
import srkCloth2 from "./srkProductsImages/srk-cloth2.jpg";
import srkCloth3 from "./srkProductsImages/srk-cloth3.jpg";
import srkCloth4 from "./srkProductsImages/srk-cloth4.jpg";
import srkCloth5 from "./srkProductsImages/srk-cloth5.jpg";
import srkCloth6 from "./srkProductsImages/srk-cloth6.jpg";
import srkConstruction1 from "./srkProductsImages/srk-construction1.jpg";
import srkConstruction2 from "./srkProductsImages/srk-construction2.jpg";
import srkElec1 from "./srkProductsImages/srk-elec1.jpg";
import srkElec2 from "./srkProductsImages/srk-elec2.jpg";
import srkElec3 from "./srkProductsImages/srk-elec3.jpg";
import srkElec4 from "./srkProductsImages/srk-elec4.jpg";
import srkElec5 from "./srkProductsImages/srk-elec5.jpg";
import srkFlag1 from "./srkProductsImages/srk-flag1.jpg";
import srkFlag2 from "./srkProductsImages/srk-flag2.jpg";
import srkFootwear1 from "./srkProductsImages/srk-footwear1.jpg";
import srkFootwear2 from "./srkProductsImages/srk-footwear2.jpg";
import srkFootwear3 from "./srkProductsImages/srk-footwear3.jpg";
import srkFootwear4 from "./srkProductsImages/srk-footwear4.jpg";
import srkFootwear5 from "./srkProductsImages/srk-footwear5.jpg";
import srkFootwear6 from "./srkProductsImages/srk-footwear6.jpg";
import srkFootwear7 from "./srkProductsImages/srk-footwear7.jpg";
import srkFootwear8 from "./srkProductsImages/srk-footwear8.jpeg";
import srkFootwear9 from "./srkProductsImages/srk-footwear9.jpeg";
import srkGiftBox1 from "./srkProductsImages/srk-giftBox1.jpg";
import srkGiftBox2 from "./srkProductsImages/srk-giftBox2.jpg";
import srkHomeApplience1 from "./srkProductsImages/srk-homeApplience1.jpg";
import srkHomeApplience2 from "./srkProductsImages/srk-homeApplience2.jpg";
import srkHomeApplience3 from "./srkProductsImages/srk-homeApplience3.jpg";
import srkHomeApplience4 from "./srkProductsImages/srk-homeApplience4.jpg";
import srkHomeApplience5 from "./srkProductsImages/srk-homeApplience5.jpg";
import srkHomeApplience6 from "./srkProductsImages/srk-homeApplience6.jpg";
import srkHomeApplience7 from "./srkProductsImages/srk-homeApplience7.jpg";
import srkHomeApplience8 from "./srkProductsImages/srk-homeApplience8.jpg";
import srkHomeApplience9 from "./srkProductsImages/srk-homeApplience9.jpg";
import srkKitchen1 from "./srkProductsImages/srk-kitchen1.jpg";
import srkKitchen2 from "./srkProductsImages/srk-kitchen2.jpg";
import srkKitchen3 from "./srkProductsImages/srk-kitchen3.jpg";
import srkKitchen4 from "./srkProductsImages/srk-kitchen4.jpg";
import srkKitchen5 from "./srkProductsImages/srk-kitchen5.jpg";
import srkKitchen6 from "./srkProductsImages/srk-kitchen6.jpeg";
import srkMachinary1 from "./srkProductsImages/srk-machinary1.jpg";
import srkMachinary2 from "./srkProductsImages/srk-machinary2.jpg";
import srkMachinary3 from "./srkProductsImages/srk-machinary3.jpg";
import srkMachinary4 from "./srkProductsImages/srk-machinary4.jpg";
import srkMachinary5 from "./srkProductsImages/srk-machinary5.jpg";
import srkMachinary6 from "./srkProductsImages/srk-machinary6.jpg";
import srkOil1 from "./srkProductsImages/srk-oil1.jpg";
import srkOil2 from "./srkProductsImages/srk-oil1.jpg";
import srkOil3 from "./srkProductsImages/srk-oil3.jpg";
import srkPaperCup1 from "./srkProductsImages/srk-paper-cup.jpg";
import srkPaperCup2 from "./srkProductsImages/srk-paper-cup1.jpg";
import srkInquiryBg from "./srkInquireImages/inquire-bg.jpg";
import srkPaperBox1 from "./srkProductsImages/srk-paperBox1.jpeg";
import srkPaperBox2 from "./srkProductsImages/srk-paperBox2.jpeg";
import srkStick1 from "./srkProductsImages/srk-stick1.jpeg";
import srkStick2 from "./srkProductsImages/srk-stick2.jpeg";
import srkKoraiBag1 from "./srkProductsImages/srk-koraiBag1.jpg";
import srkKoraiBag2 from "./srkProductsImages/srk-koraiBag2.jpg";
import srkKoraiMat1 from "./srkProductsImages/srk-koraiMat1.jpg";
import srkKoraiMat2 from "./srkProductsImages/srk-koraiMat2.jpg";
import srkKoraiMat3 from "./srkProductsImages/srk-koraiMat3.jpg";
import srkKoraiMat4 from "./srkProductsImages/srk-koraiMat4.jpg";
import srkKoraiMat5 from "./srkProductsImages/srk-koraiMat5.jpg";
import srkKoraiMat6 from "./srkProductsImages/srk-koraiMat6.jpg";
import srkKoraiMat7 from "./srkProductsImages/srk-koraiMat7.jpg";
import srkKoraiMat8 from "./srkProductsImages/srk-koraiMat8.jpg";


export const iconsAndImages = {
    logo,
    homePageBg,
    messageRightIcon,
    messageHomeIcon,
    transDetailsIcon1,
    transDetailsIcon2,
    transDetailsIcon3,
    wholesaleIcon1,
    wholesaleIcon2,
    wholesaleIcon3,
    wholesaleIcon4,
    catalogImage1,
    srkApart1,
    srkApart2,
    srkApart3,
    srkInfraIcon,
    srkConversationIcon,
    catalogHorbor,
    catalogJivraj,
    catalogAmazonAtlantis,
    catalogEcoBag,
    srkTragderQualityCommunity,
    srkAboutImage,
    srkLocation,
    srkEmail,
    srkPhone,
    srkExportProducts,
    srkInfraImage,
    productBannerImage,
    srkFooterLogo,

    //product
    srkCardamom1,
    srkBizzaBox1,
    srkBizzaBox2,
    srkCakeBox1,
    srkCakeBox2,
    srkPaperBox1,
    srkPaperBox2,
    srkStick1,
    srkStick2,
    srkCandy1,
    srkCandy2,
    srkCandy3,
    srkCandy4,
    srkCloth1,
    srkCloth2,
    srkCloth3,
    srkCloth4,
    srkCloth5,
    srkCloth6,
    srkConstruction1,
    srkConstruction2,
    srkElec1,
    srkElec2,
    srkElec3,
    srkElec4,
    srkElec5,
    srkFlag1,
    srkFlag2,
    srkFootwear1,
    srkFootwear2,
    srkFootwear3,
    srkFootwear4,
    srkFootwear5,
    srkFootwear6,
    srkFootwear7,
    srkFootwear8,
    srkFootwear9,
    srkGiftBox1,
    srkGiftBox2,
    srkHomeApplience1,
    srkHomeApplience2,
    srkHomeApplience3,
    srkHomeApplience4,
    srkHomeApplience5,
    srkHomeApplience6,
    srkHomeApplience7,
    srkHomeApplience8,
    srkHomeApplience9,
    srkKitchen1,
    srkKitchen2,
    srkKitchen3,
    srkKitchen4,
    srkKitchen5,
    srkKitchen6,
    srkMachinary1,
    srkMachinary2,
    srkMachinary3,
    srkMachinary4,
    srkMachinary5,
    srkMachinary6,
    srkOil1,
    srkOil2,
    srkOil3,
    srkPaperCup1,
    srkPaperCup2,
    srkInquiryBg,
    srkKoraiBag1,
    srkKoraiBag2,
    srkKoraiMat1,
    srkKoraiMat2,
    srkKoraiMat3,
    srkKoraiMat4,
    srkKoraiMat5,
    srkKoraiMat6,
    srkKoraiMat7,
    srkKoraiMat8
};